import Layout from '@modules/layout/components/layout.vue';
import Permissions from '@security/permissions';

const PositionListPage = () =>
  import('@modules/position/components/position-list-page.vue');
const PositionFormPage = () =>
  import('@modules/position/components/position-form-page.vue');
const PositionViewPage = () =>
  import('@modules/position/components/position-view-page.vue');
const PositionImporterPage = () =>
  import('@modules/position/components/position-importer-page.vue');

export default [
  {
    name: '',
    path: '',
    component: Layout,
    meta: { auth: true },
    children: [
      {
        name: 'position',
        path: '/position',
        component: PositionListPage,
        meta: {
          auth: true,
          permission: Permissions.values.positionView,
        },
      },
      {
        name: 'positionNew',
        path: '/position/new',
        component: PositionFormPage,
        meta: {
          auth: true,
          permission: Permissions.values.positionCreate,
        },
      },
      {
        name: 'positionImporter',
        path: '/position/import',
        component: PositionImporterPage,
        meta: {
          auth: true,
          permission: Permissions.values.positionImport,
        },
      },
      {
        name: 'positionEdit',
        path: '/position/:id/edit',
        component: PositionFormPage,
        meta: {
          auth: true,
          permission: Permissions.values.positionEdit,
        },
        props: true,
      },
      {
        name: 'positionView',
        path: '/position/:id',
        component: PositionViewPage,
        meta: {
          auth: true,
          permission: Permissions.values.positionView,
        },
        props: true,
      },
    ],
  },
];
